/* eslint-disable no-unreachable */
import {Camera} from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import {Box, Divider, IconButton, Stack, TextField, Typography} from '@mui/material';
import {useRef} from 'react';
import Counter from 'src/components/inputs/Counter';
import FileUploadField from 'src/components/inputs/ImageCropPicker.js/FileUploadField';
import {ItemPrice} from 'src/components/Price';
import {getImageFormat} from 'src/utils/imageUtils';
import {getNumber} from 'src/utils/numberUtils';
import {getImageSrc} from 'src/utils/productUtils';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import SimpleFileUploadField from 'src/components/inputs/ImageCropPicker.js/SimpleFileUploadField';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

/* 
	item will contain all attributes from product  (IFF variatoni: common attributes overriden variation attributes like price and qty, name )
	check addItem method in ProductsGridSelectionItem.jsx
*/
export default function SimpleCartItem({
	item,
	handleItemChange = (id, changes) => {},
	handleItemQuantityChange,
	handleRemoveItem,
}) {
	const {price: defaultPrice, discount: defaultDiscount} = useRef(item).current;

	// const item_available_qty = item.infinite ? 10000 : item.derived.branch_quantity;
	return (
		<Stack spacing={2}>
			<Stack gap={2} direction={{xs: 'column', sm: 'row'}} justifyContent="space-between">
				<Stack alignItems="top" spacing={2} direction="row">
					<SimpleFileUploadField
						value={item.image}
						onChange={(imageId, imageObj) =>
							handleItemChange(item.id, {image: getImageFormat(imageObj, 'small')})
						}
					/>

					<Stack>
						<Stack spacing={1} direction="row" justifyContent="space-between">
							<TextField
								fullWidth
								label="اسم المنتج"
								value={item.name}
								onChange={(e) => handleItemChange(item.id, {name: e.target.value})}
							/>

							<TextField
								fullWidth
								type="text"
								pattern="\d*"
								InputProps={{min: 0}}
								label="السعر"
								value={item.price}
								onChange={(e) => handleItemChange(item.id, {price: e.target.value})}
							/>
						</Stack>
					</Stack>
				</Stack>

				<Stack spacing={1} direction="row" alignItems={'center'}>
					<Counter
						defaultValue={item.selectedQuantity}
						onChange={(newValue) => handleItemQuantityChange(item.id, newValue)}
						min={1}
						max={10000}
					/>

					<IconButton
						sx={{opacity: 0.8}}
						color="error"
						onClick={() => {
							handleRemoveItem(item.id);
						}}
					>
						<DeleteIcon fontSize="small" />
					</IconButton>
				</Stack>
			</Stack>

			{/* <Dev title={'item (JSON)'} object={item} /> */}
			<Divider />
		</Stack>
	);
}

const getAvailableQuantity = (item, branch) => {
	if (item.infinite) return '∞';
	if (!branch) return item.derived.branch_quantity;
	const stock = item.stocks.find((b) => item.variation == b.variation && b.branch == branch);
	return getNumber(stock?.quantity, item.derived.branch_quantity);
};
